import ApiClient from "./ApiClient";

let organisationId = null;

const PayrollClientFactory = () => {
  return () =>
    ApiClient({
      baseURL: `/api/payroll/${organisationId ?? 0}`,
    });
};

export const setOrganisationId = (id) => {
  organisationId = id;
};

const PayrollClient = PayrollClientFactory();

export default PayrollClient;
